import { SubmissionStatus } from "../types";

export const isCancelledOrExpired = (status: SubmissionStatus) =>
  [SubmissionStatus.CANCELLED, SubmissionStatus.EXPIRED].includes(status);
